var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComposerNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63024 15.4696L2.25016 16.0896L10.8752 13.2146L12.7918 7.46456L12.8128 7.4436L8.97946 3.61026L8.9585 3.63123L3.2085 5.54789L0.333496 14.1729L0.953418 14.7928L5.26592 10.4803C5.17607 10.2916 5.12516 10.082 5.12516 9.86039C5.12516 9.06677 5.76904 8.42289 6.56266 8.42289C7.35628 8.42289 8.00016 9.06677 8.00016 9.86039C8.00016 10.654 7.35628 11.2979 6.56266 11.2979C6.34105 11.2979 6.13141 11.247 5.94274 11.1571L1.63024 15.4696ZM9.65628 2.93344L13.4896 6.76677L15.6668 4.58956L11.8335 0.756226L9.65628 2.93344Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposerNavigation);
export default __webpack_public_path__ + "static/media/composer-navigation.a53c51427274a82217673b086bc4998f.svg";
export { ForwardRef as ReactComponent };